import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { GestioneUtentiComponent } from './gestione-utenti.component';

@NgModule({
  declarations: [
    GestioneUtentiComponent
  ],
  imports: [
    SharedModule
  ],
  exports: [
    GestioneUtentiComponent
  ]
})
export class GestioneUtentiModule { }
